// 标题栏类型定义
export interface ICourseTitleBar {
  id: number;
  title: string;
  viewCount: number;
  tenantId: number;
  showDiscountPrice: boolean; // 是否显示折扣价
  fixedPrice: number; // 折扣价
  price: number; // 原价
  remainingDiscountTime: number | null;
  hadBuyed: boolean; // 是否已购买
  restrictionSwitch: null | boolean;
  hadRegistration: null | boolean;
  shortUrl: string;
  type: number;
  liveCourseLessonId: null | string | number;
  hadFavorite: boolean;
  teacherBackground: string | null;
  teacherName: string;
  teacherAvatarUrl: string | null;
  assistantQrCode: string | null;
  contentType: null | number;
  courseContentLink: string;
}

// 学习进度类型定义
export interface ICourseProgress {
  maxProgress: number;
  nowProgress: number;
  courseId: number;
  chapterId: number;
}

// 学习课程评价类型定义
export interface ICourseReview {
  hadReview: boolean;
  star: number;
}

export const PAID_COURSE_TEXT = '请通过美团APP、微信、手机浏览器扫码确认订单。';
export const REGISTER_COURSE_TEXT = '请通过美团APP、微信、手机浏览器扫码填写报名表。';
